import React, { SetStateAction, useState } from 'react';
import CommonConfigDialog from './CommonConfigDialog';
import { RequiredDialogInput, RequiredDialogSelect, DialogCheckbox, DialogInput } from '../../DialogInputs';
import { handleInputChange } from '../../Utilities/DialogUtils';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import { Line } from '../../Types/Line';
import { BusinessUnit } from '../../Types/BusinessUnit';

interface LineEditDialogProps {
    dialogData: Line,
    setDialogData: React.Dispatch<SetStateAction<Line>>,
    showDialog: boolean,
    closeDialog: Function,
    businessUnits: BusinessUnit[]
}

function LineEditDialog({ dialogData, setDialogData, showDialog, closeDialog, businessUnits }: LineEditDialogProps) {

    const { fetchDataAuthenticated } = useHttpUtils();
    const [fieldErrors, setFieldErrors] = useState<Partial<Line>>({});

    const saveLine = (line: Line) => {

        let promise = new Promise((resolve, reject) => {
            let url = `api/v1/line`;
            if (line.lineId != null) {
                url += `/${line.lineId}`
            }

            fetchDataAuthenticated(url, "POST", JSON.stringify(line))
                .then(response => response.json())
                .then(data => {
                    if (data.errors !== null && data.errors !== undefined) {
                        reject(data);
                    }
                    resolve(data);
                })
                .catch(error => {
                    alert("there was a problem!" + error);
                });

        });

        return promise;
    };

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    }

    return (
        <CommonConfigDialog title={"Line - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveLine} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors}>
            <RequiredDialogInput controlId="formLineName" title="Name" name="name" placeholder="Name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <RequiredDialogSelect controlId="formLineBusinessUnit" title="Business Unit" name="businessUnitId" value={dialogData.businessUnitId} error={fieldErrors.businessUnitId} onChange={onChange}>
                <option value="" key={0} >Please Select...</option>
                {businessUnits.map((bu) => <option value={bu.businessUnitId} key={bu.businessUnitId}>{bu.name}</option>)}
            </RequiredDialogSelect>
            <RequiredDialogInput controlId="formLineProductionLine" title="Production Line" name="productionLine" placeholder="Line Code" value={dialogData.productionLine} error={fieldErrors.name} onChange={onChange} />
            <DialogInput controlId="formLineReleaseSamplePoint" title="Release Sample Point" name="releaseSamplePoint" placeholder="Release Sample Point" value={dialogData.releaseSamplePoint} error={fieldErrors.name} onChange={onChange} />
            <DialogCheckbox controlId="formAllowAutoReview" title="Allow Auto Review" name="allowAutoReview" disabled={false} checked={dialogData.allowAutoReview} error={fieldErrors.allowAutoReview} onChange={onChange} />
            <DialogCheckbox controlId="formAllowAutoGrade" title="Allow Auto Grade" name="allowAutoGrade" disabled={false} checked={dialogData.allowAutoGrade} error={fieldErrors.allowAutoGrade} onChange={onChange} />
            <DialogCheckbox disabled={dialogData.lineId === null} controlId="formLineIsDeleted" title="Deleted?" name="isDeleted" checked={dialogData.isDeleted} error={fieldErrors.isDeleted} onChange={onChange} />
        </CommonConfigDialog>
    );
}

export default LineEditDialog;